module.exports = __webpack_public_path__ + "img/briefcase-blank.7e50df03.svg";